<h1 class="section-title">{{ 'workingSites.main.TITLE' | translate }}</h1>
<router-outlet></router-outlet>